<template>
  <div class="search-job-form">
    <div class="search-job-form__bg-image"
      :class="{shadow: image_shadow}">
      <lazy-image
        cover_img
        :src="image_src"
        :lazy_src="image_lazy_src"
      />
    </div>
    <div class="container search-job-form__content"
      :class="{form_hidden: hide_form}">
      <default-title
        white
        pre_wrap
        class="search-job-form__content-title"
        :upper_case="title_uppercase"
        :class="{w_100: title_full_width, w_75: title_75_width}"
        :title="form_title"
      />
<!--      <inline-form-with-voice-search-->
<!--        v-if="!hide_form"-->
<!--        add_badge-->
<!--        :input_placeholder="$t('input_placeholder.search_key_words')"-->
<!--        v-model="search_val"-->
<!--        @submit="searchForm"-->
<!--      />-->
      <default-button
        v-if="has_button_link"
        class="mt-20"
        :href="button_link">
        {{button_text}}
      </default-button>
    </div>
  </div>
</template>

<script>

import LazyImage from "../small_parts/LazyImage.vue";
import DefaultTitle from "../small_parts/DefaultTitle.vue";
import DefaultButton from "../slots/DefaultButton.vue";

export default {
  name: "SearchJobForm",
  components: {
    DefaultButton,
    DefaultTitle,
    LazyImage
  },
  props: {
    /**props**/
    image_src: {
      type: String,
      required: true,
      admin_type: 'image',
    },
    image_lazy_src: {
      type: String,
      default: '',
      admin_type: 'image',
    },
    image_shadow: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    title_full_width: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    title_75_width: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    title_uppercase: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    form_title: {
      type: String,
      default: '',
      admin_type: 'textarea',
    },
    hide_form: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    button_text: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    button_link: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    /**props**/
  },
  computed: {
    has_button_link() {
      return this.button_text && this.button_link
    },
  },
  data() {
    return {
      search_val: ''
    }
  },
  methods: {
    searchForm() {
      // console.log(this.search_val);
    }
  }
}
</script>
